const formValidation = require('../base/components/formValidation');

/**
 * appends params to a url
 * @param {string} url - Original url
 * @param {Object} params - Parameters to append
 * @returns {string} result url with appended parameters
 */
function appendToUrl(url, params) {
    var newUrl = url;
    newUrl += (newUrl.indexOf('?') !== -1 ? '&' : '?') + Object.keys(params).map(function (key) {
        return key + '=' + encodeURIComponent(params[key]);
    }).join('&');

    return newUrl;
}

/**
 * Clears all values of a form
 *
 * @param {Form} form The form to be cleared
 */
function clearForm(form) {
    // iterate over all of the inputs for the form
    // element that was passed in
    $(':input', form).each(function () {
        var type = this.type;
        var tag = this.tagName.toLowerCase();
        if (type === 'text' || type === 'password' || tag === 'textarea' || tag === 'email') {
            this.value = '';
        } else if (type === 'checkbox' || type === 'radio') {
            this.checked = false;
        } else if (tag === 'select') {
            this.selectedIndex = -1;
        }
    });
}

module.exports = {
    sendMessage: function () {
        $('form.contact-form').submit(function (e) {
            let $form = $(this);
            e.preventDefault();

            var $recaptchaField = $('#g-recaptcha-response');
            if ($recaptchaField.val() === '') {
                $('.g-recaptcha').addClass('error');

                return false;
            }

            let url = $form.attr('action');
            $form.spinner().start();
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: $form.serialize(),
                success: function (data) {
                    if ($('.add-to-cart-messages').length === 0) {
                        $('body').append(
                            '<div class="add-to-cart-messages"></div>'
                        );
                    }
                    $form.spinner().stop();
                    if (!data.success) {
                        formValidation($form, data);
                    } else {
                        $('#messageContact').val('');

                        grecaptcha.reset();

                        clearForm($form);

                        $('.add-to-cart-messages').append(
                            '<div class="alert alert-success add-to-basket-alert text-center" role="alert">'
                            + data.confirmationObject.message
                            + '</div>'
                        );
                    }
                },
                error: function (data) {
                    $('.add-to-cart-messages').append(
                        '<div class="alert alert-danger add-to-basket-alert text-center" role="alert">'
                        + data.confirmationObject.message
                        + '</div>'
                    );
                    $form.spinner().stop();
                },
                complete: function () {
                    setTimeout(function () {
                        $('.add-to-basket-alert').remove();
                    }, 5000);
                }
            });

            return false;
        });

        return false;
    },
    didyoumean: function () {
        $('body').on('blur', '.did-you-mean-holder', function () {
            var url = $(this).data('url');
            var email = $(this).val();
            var $this = $(this);

            let urlParams = {
                email: email
            };

            var $wrapper = $this.parent();
            url = appendToUrl(url, urlParams);

            $this.removeClass('is-invalid');

            $wrapper.removeClass('is-valid is-invalid');
            $wrapper.addClass('is-validating');


            $this.attr('disabled', 'disabled');

            $wrapper.find('.searching-feedback').removeClass('d-none');

            $.ajax({
                url: url,
                type: 'get',
                success: function (data) {
                    if (!data.valid) {
                        $this.closest('form').find(':submit').attr('disabled', 'disabled');
                        $this.removeAttr('disabled', 'disabled');
                        $wrapper.removeClass('is-validating is-valid');
                        $this.addClass('is-invalid');

                        if (data.message) {
                            $wrapper.find('.invalid-feedback').html(data.message);
                            $this.addClass('is-invalid');
                        }
                        if (data.didyoumean) {
                            $wrapper.find('.invalid-feedback').html(data.message);
                            $this.addClass('is-invalid');
                        }
                    } else {
                        $this.removeAttr('disabled', 'disabled');
                        $wrapper.removeClass('is-validating is-invalid');
                        $wrapper.addClass('is-valid');
                        $this.closest('form').find(':submit').removeAttr('disabled');
                    }
                },
                error: function () {
                    $this.removeAttr('disabled', 'disabled');
                    $wrapper.removeClass('is-validating is-invalid is-valid');
                    $this.closest('form').find(':submit').removeAttr('disabled');
                },
                complete: function () {
                    $wrapper.find('.searching-feedback').addClass('d-none');
                }
            });
            return false;
        });
        $('body').on('click', '.did-you-mean', function () {
            var $group = $(this).closest('.form-group');
            var $holder = $group.find('.did-you-mean-holder');

            $holder.val($(this).text());
            $holder.removeClass('is-invalid');

            $holder.removeAttr('disabled', 'disabled');
            $holder.parent().removeClass('is-validating is-invalid');
            $holder.parent().addClass('is-valid');
        });
    },
    validateSubject: function () {
        const subjectContact = document.getElementById('subjectContact');
        if (subjectContact) {
            subjectContact.addEventListener('input', function (event) {
                const pattern = /[^\x20-\x7F\xC0-\xFF\n\s€]/g;
                const value = event.target.value;
                const newValue = value.replace(pattern, '');
                if (newValue !== value) {
                    var updatedEvent = event;
                    updatedEvent.target.value = newValue;
                }
            });
        }
    }
};
